var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload-button",attrs:{"align":"center"}},[_c('input',{style:({ 'font-size': _vm.touchSize + 'rem' }),attrs:{"type":"file","value":"","accept":"image/*","multiple":_vm.multiple},on:{"change":_vm.bindchange_chooseImages}})])
}
var staticRenderFns = []

export { render, staticRenderFns }